// import React, { Fragment, useState } from 'react'
// import { useNavigate } from 'react-router-dom';
// const resourcesData = {
//     categories: [
//         { id: 1, title: "Guides", description: "In-depth resources to help you navigate challenges.", image: "/Resources/book.svg", color: "`bg-blue-100`" },
//         { id: 2, title: "Blog", description: "Expert insights on mental health and wellness.", image: "/Resources/edit.svg", color: "bg-green-100" },
//         { id: 3, title: "Assessments", description: "Self-assessments to better understand your needs.", image: "/Resources/brain.svg", color: "bg-purple-100" },
//         { id: 4, title: "FAQs", description: "Answers to common questions about mental healthcare.", image: "/Resources/question.svg", color: "bg-orange-100" },
//     ],
//     articles: [
//         { id: 1, title: "All About Breast Cance", description: "Breast cancer is a condition where the cells in the breast grow out of control. Breast cancer begins in different parts of the breast, which", tag: "August 22, 2024", readTime: "8 min read", image: "/Resources/Blog1.svg" },
//         { id: 2, title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS", description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue. While lifestyle changes such as exercise and", tag: "August 22, 2024", readTime: "5 min read", image: "/Resources/Blog2.svg" },
//         { id: 3, title: "Everything You Need to Know About Premenstrual Syndrome (PMS)", description: "Premenstrual Syndrome (PMS) is a common condition that affects women of reproductive age. It is characterized by various physical and emotional symptoms that occur during", tag: "June 26, 2024", readTime: "10 min read", image: "/Resources/Blog3.svg" },
//         { id: 4, title: "Things to Know About Premenstrual Syndrome (PMS)", description: "The Invisible Struggle: All About Premenstrual Syndrome Premenstrual syndrome (PMS) is a group of mental, emotional, physical, and behavioural disturbances experienced by a woman before", tag: "June 26, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//         { id: 5, title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS", description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue. While lifestyle changes such as exercise and", tag: "June 26, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//         { id: 6, title: "The Menopause Transition: What to Expect and How to Cope", description: "Menopause is a natural biological process that marks the end of a woman’s reproductive years. It usually occurs between the ages of 45 and 55", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//         { id:7, title: "Know More About Menopause", description: "Menopause is the end of woman’s menstrual periods, and she can no longer bear children. It is a natural part of aging and usually occurs", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//          { id: 8, title: "Hormonal Imbalances: Living with PCOS and Finding Relief", description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS). PCOS affects up to 10% of women of", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//           { id: 9, title: "High-Risk Pregnancy: How to Ensure a Safe and Healthy Delivery", description: "Pregnancy is a joyful experience, but it can also be challenging, especially when you have a high-risk pregnancy. High risk pregnancy occurs when the mother", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//           { id: 10, title: "All About High-risk Pregnancy", description: "A pregnancy in which the mother or baby is at an increased risk for complications or health problems. Certain health conditions and age (over 35", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//           { id: 11, title: "Understanding PCOS: Symptoms, Causes, and Treatment Options", description: "Polycystic ovary syndrome (PCOS) is a common hormonal disorder affecting women of reproductive age. It is estimated that 1 in 10 women of childbearing age", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//            { id: 12, title: "Vaginal Cancer: Early Detection and Prevention Strategies", description: "Vaginal cancer is a rare but serious condition that can affect women of all ages. While the exact causes of vaginal cancer are unknown, there", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//            { id: 13, title: "Everything You Need to Know About Vaginal Cancer", description: "What is Vaginal Cancer? Vaginal cancer is one of the rarest cancers affecting the female reproductive system. The vagina (birth canal) is the pathway through", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//             { id: 14, title: "Hormonal Imbalances: Living with PCOS and Finding Relief", description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS). PCOS affects up to 10% of women of", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" }, 
//             { id: 15, title: "The Role of Nutrition in Female Fertility", description: "When it comes to the journey of starting a family, many factors can influence a woman’s fertility. While genetics, lifestyle choices, and medical conditions play", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/Blog4.svg" },
//     ],
//     assessments: [
//         { id: 1, title: "Anxiety Check-In", description: "Understand your anxiety symptoms and their impact.", time: "5–7 min", image: "/Resources/icon1.svg", iconBg: "primary-bg" },
//         { id: 2, title: "Depression Check-In", description: "Explore your mood and get personalized insights.", time: "6–7 min", image: "/Resources/icon2.svg", iconBg: "bg-green-100" },
//         { id: 3, title: "Sleep Health Check", description: "Evaluate your sleep patterns and discover ways to improve.", time: "4–6 min", image: "/Resources/icon3.svg", iconBg: "bg-purple-100" },
//         { id: 4, title: "Stress Check-In", description: "Identify stress triggers and learn how to manage them.", time: "5–6 min", image: "/Resources/icon4.svg", iconBg: "bg-orange-100" },
//     ],
// };
// const tagConfig = {
//     GUIDE: { bg: "bg-blue-100", text: "text-blue-700" },
//     BLOG: { bg: "bg-green-100", text: "text-green-700" },
//     WELLNESS: { bg: "bg-red-100", text: "text-red-600" },
//     MINDFULNESS: { bg: "bg-purple-100", text: "text-purple-700" },
// };
// const ResourceData = () => {
//     const [query, setQuery] = useState("");
//     const navigate = useNavigate();
//  const [startIndex, setStartIndex] = useState(0);
//   const [visibleCount, setVisibleCount] = useState(1);
//     const filteredArticles = resourcesData.articles.filter((a) =>
//         a.title.toLowerCase().includes(query.toLowerCase())
//     );
//       React.useEffect(() => {
//         const updateCount = () => {
//           const width = window.innerWidth;
//           if (width >= 1024) setVisibleCount(4);
//           else if (width >= 640) setVisibleCount(2);
//           else setVisibleCount(1);
//         };
//         updateCount();
//         window.addEventListener("resize", updateCount);
//         return () => window.removeEventListener("resize", updateCount);
//       }, []);

//   const hasMore = filteredArticles.length > visibleCount;
//   const maxStart = Math.max(0, filteredArticles.length - visibleCount);
//   const canPrev = startIndex > 0;
//   const canNext = startIndex < maxStart;

//   React.useEffect(() => {
//     setStartIndex((i) => Math.min(i, Math.max(0, filteredArticles.length - visibleCount)));
//   }, [visibleCount, filteredArticles.length]);

//   const visibleItems = filteredArticles.slice(startIndex, startIndex + visibleCount);

//   const handlePrev = () => {
//     if (canPrev) setStartIndex((i) => i - 1);
//   };

//   const handleNext = () => {
//     if (canNext) setStartIndex((i) => i + 1);
//   };

//     return (
//         <div className="min-h-screen bg-white ">
//             {/* Here, I need to call hero */}

//             <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 lg:px-8 ">
//                 {/* categories section */}
//                 <div className="mb-12 rounded-2xl ava-black-border  bg-white ">
//                     <div className="flex flex-col divide-y divide-slate-100 sm:flex-row sm:divide-x sm:divide-y-0">
//                         {resourcesData.categories.map((cat) => (
//                             <div
//                                 key={cat.id}
//                                 className="group flex flex-1 cursor-pointer items-start gap-4 p-5 transition-colors duration-150  sm:flex-col sm:items-start lg:flex-row lg:items-start"
//                             >
//                                 <div className="flex h-14 w-14 secondary-bg shrink-0 items-center justify-center rounded-xl">
//                                     <img src={cat.image} alt={cat.title} className="h-6 w-6 object-contain" />
//                                 </div>
//                                 <div className="min-w-0 flex-1">
//                                     {/* ✅ Matches Conditions: font-semibold text-sm */}
//                                     <p className="mb-1 ava-text-subheading ">
//                                         {cat.title}
//                                     </p>
//                                     {/* ✅ Matches Conditions: text-xs leading-relaxed */}
//                                     <p className="ava-text-xs ">
//                                         {cat.description}
//                                     </p>

//                                 </div>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//                 {/* Featured Articles */}
//                 <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2">
//                     <div>
//                         <h2 className=" mb-1"
//                             className="ava-heading-lg "
//                         >Insights & Wellness Blogs</h2>
//                         <p className="mt-0.5 ava-text-body">
//                             Discover blogs on women's health, wellness, prevention, and everyday care.
//                         </p>
//                     </div>
//                 </div>
//                 <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//                     {filteredArticles.length > 0 ? (
//                         filteredArticles.map((article) => {
//                             const tc = tagConfig[article.tag] ||
//                                 { bg: "bg-slate-100", text: "text-slate-600" };
//                             return (
//                                 <div
//                                     key={article.id}
//                                     className="group cursor-pointer overflow-hidden ava-radius-md  bg-white ava-card-mukta 
//                                      "
//                                 >

//                                     <img src={article.image} alt={article.title}
//                                         className="w-full aspect-[3/2] sm:aspect-[4/3] md:aspect-[16/9] object-cover object-center"
//                                     />
//                                     <div className="p-4">
//                                         <div className="mb-2 flex items-center justify-between gap-2">
//                                             <span className="rounded-md  py-0.5  ava-text-caption tracking-wide ava-card-bg  whitespace-nowrap">
//                                                 {article.tag}
//                                             </span>

//                                         </div>
//                                         <p className="mb-1.5 ava-text-subheading">{article.title}</p>
//                                         <p className="mb-3 ava-text-body">{article.description}</p>
//                                         <button className="ava-text-sm">
//                                             Read more
//                                         </button>
//                                     </div>
//                                 </div>
//                             );
//                         })
//                     ) : (
//                         <p className="col-span-full text-sm text-slate-400">
//                             No articles found for &ldquo;{query}&rdquo;.
//                         </p>
//                     )}
//                 </div>


//                 {/* self assessments */}
//                 <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2">
//                     <div>
//                         <h2 className="ava-heading-lg mb-1 "
//                         >Self-Assessments</h2>
//                         <p className="mt-0.5 ava-text-xs">
//                             Take a few minutes to gain clarity and insights. Your results are private and secure.
//                         </p>
//                     </div>

//                 </div>

//                 <div className="mb-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
//                     {resourcesData.assessments.map((item) => (
//                         <div
//                             key={item.id}
//                             className="cursor-pointer rounded-2xl border  ava-card-bg ava-card-mukta p-5  "
//                         >
//                             <div className="mb-4 flex h-11 w-11 items-center justify-center secondary-bg rounded-xl">
//                                 <img src={item.image} alt={item.title} className="h-6 w-6 object-contain" />
//                             </div>
//                             {/* ✅ Matches Conditions: font-semibold text-sm */}
//                             <p className="mb-1.5 ava-text-subheading">{item.title}</p>
//                             {/* ✅ Matches Conditions: text-xs leading-relaxed */}
//                             <p className="mb-5 ava-text-xs">{item.description}</p>
//                             <div className="flex items-center justify-between ">
//                                 <span className="flex items-center gap-1 ava-text-xs ">
//                                     <div className="flex h-7 w-7 items-center justify-center rounded-full">
//                                         <img src='/Resources/time.svg' alt={item.title} className="h-4 w-4 object-contain" />
//                                     </div>
//                                     {item.time}
//                                 </span>
//                                 <button

//                                     //  style={{ backgroundColor: 'var(--secondary-color)', color: 'white' }}
//                                     className="btn-primary "

//                                 >
//                                     Start
//                                 </button>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default ResourceData
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { articles as allArticles } from './articlesData';

const resourcesData = {
    categories: [
        { id: 1, title: "Guides", description: "In-depth resources to help you navigate challenges.", image: "/Resources/book.svg" },
        { id: 2, title: "Blog", description: "Expert insights on mental health and wellness.", image: "/Resources/edit.svg" },
        { id: 3, title: "Assessments", description: "Self-assessments to better understand your needs.", image: "/Resources/brain.svg" },
        { id: 4, title: "FAQs", description: "Answers to common questions about mental healthcare.", image: "/Resources/question.svg" },
    ],
    articles: [
        { id: 1, title: "All About Breast Cancer", description: "Breast cancer is a condition where the cells in the breast grow out of control. Breast cancer begins in different parts of the breast, which", tag: "August 22, 2024", readTime: "8 min read", image: "/Resources/breastCancer.png" },
        { id: 2, title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS", description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue. While lifestyle changes such as exercise and", tag: "August 22, 2024", readTime: "5 min read", image: "/Resources/diet.jpg" },
        { id: 3, title: "Everything You Need to Know About Premenstrual Syndrome (PMS)", description: "Premenstrual Syndrome (PMS) is a common condition that affects women of reproductive age. It is characterized by various physical and emotional symptoms that occur during", tag: "June 26, 2024", readTime: "10 min read", image: "/Resources/pms.jpg" },
        { id: 4, title: "Things to Know About Premenstrual Syndrome (PMS)", description: "The Invisible Struggle: All About Premenstrual Syndrome Premenstrual syndrome (PMS) is a group of mental, emotional, physical, and behavioural disturbances experienced by a woman before", tag: "June 26, 2024", readTime: "6 min read", image: "/Resources/pms2.jpg" },
        { id: 5, title: "The Food-Mood Connection: Understanding the Link Between Your Diet and PMS", description: "Premenstrual Syndrome (PMS) can be challenging to manage, with symptoms ranging from mood swings to bloating and fatigue. While lifestyle changes such as exercise and", tag: "June 26, 2024", readTime: "6 min read", image: "/Resources/pms3.jpg" },
        { id: 6, title: "The Menopause Transition: What to Expect and How to Cope", description: "Menopause is a natural biological process that marks the end of a woman's reproductive years. It usually occurs between the ages of 45 and 55", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/menopause.jpg" },
        { id: 7, title: "Know More About Menopause", description: "Menopause is the end of woman's menstrual periods, and she can no longer bear children. It is a natural part of aging and usually occurs", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/menopause2.jpg" },
        { id: 8, title: "Hormonal Imbalances: Living with PCOS and Finding Relief", description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS). PCOS affects up to 10% of women of", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/hormonal.jpg" },
        { id: 9, title: "High-Risk Pregnancy: How to Ensure a Safe and Healthy Delivery", description: "Pregnancy is a joyful experience, but it can also be challenging, especially when you have a high-risk pregnancy. High risk pregnancy occurs when the mother", tag: "March 29, 2024", readTime: "6 min read", image: "/Resources/pregRisk.jpg" },
        { id: 10, title: "All About High-risk Pregnancy", description: "A pregnancy in which the mother or baby is at an increased risk for complications or health problems. Certain health conditions and age (over 35", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/pregRisk2.jpg" },
        { id: 11, title: "Understanding PCOS: Symptoms, Causes, and Treatment Options", description: "Polycystic ovary syndrome (PCOS) is a common hormonal disorder affecting women of reproductive age. It is estimated that 1 in 10 women of childbearing age", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/pcos-age.jpg" },
        { id: 12, title: "Vaginal Cancer: Early Detection and Prevention Strategies", description: "Vaginal cancer is a rare but serious condition that can affect women of all ages. While the exact causes of vaginal cancer are unknown, there", tag: "September 19, 2023", readTime: "6 min read", image: "/Resources/Vaginal-Cancer-1.jpg" },
        { id: 13, title: "Everything You Need to Know About Vaginal Cancer", description: "What is Vaginal Cancer? Vaginal cancer is one of the rarest cancers affecting the female reproductive system. The vagina (birth canal) is the pathway through", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/Vaginal-Cancer-1536x1024.jpg" },
        { id: 14, title: "Hormonal Imbalances: Living with PCOS and Finding Relief", description: "Hormonal imbalances can cause a wide range of health problems for women, including polycystic ovary syndrome (PCOS). PCOS affects up to 10% of women of", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/hormonal.jpg" },
        { id: 15, title: "The Role of Nutrition in Female Fertility", description: "When it comes to the journey of starting a family, many factors can influence a woman's fertility. While genetics, lifestyle choices, and medical conditions play", tag: "August 14, 2023", readTime: "6 min read", image: "/Resources/Female-Fertility-1.jpg" },
    ],
    assessments: [
        { id: 1, title: "Anxiety Check-In", description: "Understand your anxiety symptoms and their impact.", time: "5–7 min", image: "/Resources/icon1.svg" },
        { id: 2, title: "Depression Check-In", description: "Explore your mood and get personalized insights.", time: "6–7 min", image: "/Resources/icon2.svg" },
        { id: 3, title: "Sleep Health Check", description: "Evaluate your sleep patterns and discover ways to improve.", time: "4–6 min", image: "/Resources/icon3.svg" },
        { id: 4, title: "Stress Check-In", description: "Identify stress triggers and learn how to manage them.", time: "5–6 min", image: "/Resources/icon4.svg" },
    ],
};

const ResourceData = () => {
    const [query, setQuery] = useState("");
    const navigate = useNavigate();

    // ── Articles carousel state ──
    const [articleStart, setArticleStart] = useState(0);

    // ── Assessments carousel state ──
    const [assessStart, setAssessStart] = useState(0);

    // ── Shared visible count (responsive) ──
    const [visibleCount, setVisibleCount] = useState(1);

    React.useEffect(() => {
        const updateCount = () => {
            const width = window.innerWidth;
            if (width >= 1024) setVisibleCount(4);
            else if (width >= 640) setVisibleCount(2);
            else setVisibleCount(1);
        };
        updateCount();
        window.addEventListener("resize", updateCount);
        return () => window.removeEventListener("resize", updateCount);
    }, []);

    // ── Filtered articles ──
    // const filteredArticles = resourcesData.articles.filter((a) =>
    //     a.title.toLowerCase().includes(query.toLowerCase())
    // );
    const filteredArticles = allArticles.filter((a) =>
        a.title.toLowerCase().includes(query.toLowerCase())
    );

    // ── Reset articleStart if filteredArticles shrinks ──
    React.useEffect(() => {
        setArticleStart((i) => Math.min(i, Math.max(0, filteredArticles.length - visibleCount)));
    }, [visibleCount, filteredArticles.length]);

    // ── Articles carousel computed values ──
    const articleMax = Math.max(0, filteredArticles.length - visibleCount);
    const articleHasMore = filteredArticles.length > visibleCount;
    const articleCanPrev = articleStart > 0;
    const articleCanNext = articleStart < articleMax;
    const visibleArticles = filteredArticles.slice(articleStart, articleStart + visibleCount);

    // ── Assessments carousel computed values ──
    const assessMax = Math.max(0, resourcesData.assessments.length - visibleCount);
    const assessHasMore = resourcesData.assessments.length > visibleCount;
    const assessCanPrev = assessStart > 0;
    const assessCanNext = assessStart < assessMax;
    const visibleAssessments = resourcesData.assessments.slice(assessStart, assessStart + visibleCount);

    // ── Arrow style helper ──
    const arrowStyle = (canAct) => ({
        borderColor: canAct ? "var(--primary-color)" : "var(--gray-300)",
        opacity: canAct ? 1 : 0.4,
        cursor: canAct ? "pointer" : "not-allowed",
    });

    return (
        <div className="min-h-screen bg-white">

            <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 ava-section-gap">

                {/* ── Categories ── */}
                <div className=" rounded-2xl ava-black-border bg-white">
                    <div className="flex flex-col divide-y divide-slate-100 sm:flex-row sm:divide-x sm:divide-y-0">
                        {resourcesData.categories.map((cat) => (
                            <div
                                key={cat.id}
                                className="group flex flex-1 cursor-pointer items-start gap-4 p-5 transition-colors duration-150 sm:flex-col sm:items-start lg:flex-row lg:items-start"
                            >
                                <div className="flex h-14 w-14 secondary-bg shrink-0 items-center justify-center rounded-xl">
                                    <img src={cat.image} alt={cat.title} className="h-6 w-6 object-contain" />
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="mb-1 ava-text-subheading">{cat.title}</p>
                                    <p className="ava-text-xs">{cat.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── Insights & Wellness Blogs ── */}
                <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2 ava-section-gap">
                    <div>
                        <h2 className="ava-heading-lg mb-1">Insights & Wellness Blogs</h2>
                        <p className="mt-0.5 ava-text-body">
                            Discover blogs on women's health, wellness, prevention, and everyday care.
                        </p>
                    </div>
                </div>

                {/* Articles carousel wrapper — position:relative anchors the arrows */}
                <div className="relative ">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {visibleArticles.length > 0 ? (
                            visibleArticles.map((article) => (
                                <div
                                    key={article.id}
                                    className="group cursor-pointer overflow-hidden ava-radius-md bg-white ava-card-mukta"
                                >
                                    <img
                                        src={article.image}
                                        alt={article.title}
                                        className="w-full aspect-[3/2] sm:aspect-[4/3] md:aspect-[16/9] object-cover object-center"
                                    />
                                    <div className="p-4">
                                        <div className="mb-2 flex items-center justify-between gap-2">
                                            <span className="rounded-md py-0.5 ava-text-caption tracking-wide ava-card-bg whitespace-nowrap">
                                                {article.tag}
                                            </span>
                                        </div>
                                        <p className="mb-1.5 ava-text-subheading">{article.title}</p>
                                        <p className="mb-3 ava-text-body">{article.description}</p>
                                        {/* <button className="ava-text-sm">Read more</button> */}
                                        <button
                                            className="ava-text-sm flex items-center transition-transform duration-300 group-hover:translate-x-1   gap-1 justify-center"
                                            style={{color:"var(--primary-color)"}}
                                            onClick={() => navigate(`/resource/${article.slug}`)}
                                        >
                                            Read more   <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M5 12h14M13 6l6 6-6 6" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="col-span-full text-sm text-slate-400">
                                No articles found for &ldquo;{query}&rdquo;.
                            </p>
                        )}
                    </div>

                    {/* Left arrow */}
                    {articleHasMore && (
                        <button
                            onClick={() => articleCanPrev && setArticleStart((i) => i - 1)}
                            disabled={!articleCanPrev}
                            aria-label="Previous articles"
                            className="flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200 shadow-md"
                            style={arrowStyle(articleCanPrev)}
                        >
                            <img src="/images/left-arrow.svg" alt="Previous" className="w-10 h-10" />
                        </button>
                    )}

                    {/* Right arrow */}
                    {articleHasMore && (
                        <button
                            onClick={() => articleCanNext && setArticleStart((i) => i + 1)}
                            disabled={!articleCanNext}
                            aria-label="Next articles"
                            className="flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200 shadow-md"
                            style={arrowStyle(articleCanNext)}
                        >
                            <img src="/images/right-arrow.svg" alt="Next" className="w-10 h-10" />
                        </button>
                    )}
                </div>

                {/* ── Self-Assessments ── */}
                <div className="mb-5 flex flex-wrap items-baseline justify-between gap-2 ava-section-gap">
                    <div>
                        <h2 className="ava-heading-lg mb-1">Self-Assessments</h2>
                        <p className="mt-0.5 ava-text-xs">
                            Take a few minutes to gain clarity and insights. Your results are private and secure.
                        </p>
                    </div>
                </div>

                {/* Assessments carousel wrapper */}
                <div className="relative ">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                        {visibleAssessments.map((item) => (
                            <div
                                key={item.id}
                                className="cursor-pointer rounded-2xl border ava-card-bg ava-card-mukta p-5"
                            >
                                <div className="mb-4 flex h-11 w-11 items-center justify-center secondary-bg rounded-xl">
                                    <img src={item.image} alt={item.title} className="h-6 w-6 object-contain" />
                                </div>
                                <p className="mb-1.5 ava-text-subheading">{item.title}</p>
                                <p className="mb-5 ava-text-xs">{item.description}</p>
                                <div className="flex items-center justify-between">
                                    <span className="flex items-center gap-1 ava-text-xs">
                                        <div className="flex h-7 w-7 items-center justify-center rounded-full">
                                            <img src='/Resources/time.svg' alt="" className="h-4 w-4 object-contain" />
                                        </div>
                                        {item.time}
                                    </span>
                                    <button className="btn-primary">Start</button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Left arrow */}
                    {assessHasMore && (
                        <button
                            onClick={() => assessCanPrev && setAssessStart((i) => i - 1)}
                            disabled={!assessCanPrev}
                            aria-label="Previous assessments"
                            className="flex absolute -left-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
                            style={arrowStyle(assessCanPrev)}
                        >
                            <img src="/images/left-arrow.svg" alt="Previous" className="w-10 h-10" />
                        </button>
                    )}

                    {/* Right arrow */}
                    {assessHasMore && (
                        <button
                            onClick={() => assessCanNext && setAssessStart((i) => i + 1)}
                            disabled={!assessCanNext}
                            aria-label="Next assessments"
                            className="flex absolute -right-5 top-1/2 -translate-y-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white border transition-all duration-200"
                            style={arrowStyle(assessCanNext)}
                        >
                            <img src="/images/right-arrow.svg" alt="Next" className="w-10 h-10" />
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
};

export default ResourceData;